<div class="top-bar">
	<ng-content select="[filter-view-filter-bar]"></ng-content>
	<ng-content select="[filter-view-options-bar]"></ng-content>
</div>
<ng-content select="[filter-view-content]"></ng-content>
<ng-content select="[filter-view-content-loading-bar]"></ng-content>
<ng-content select="[filter-view-action-bar]"></ng-content>
